import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "transfer-options__info" };
const _hoisted_2 = { class: "form__group" };
const _hoisted_3 = { class: "form__label-wrapper" };
const _hoisted_4 = {
    class: "form__label",
    for: "inputFile"
};
const _hoisted_5 = ["accept"];
const _hoisted_6 = { class: "form-buttons" };
const _hoisted_7 = ["disabled"];
import { ref } from 'vue';
import { uploadShopImportProfileFile } from '../commands/UploadShopImportProfileFile';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ImportProfileTransferUpload',
    props: {
        profile: {}
    },
    setup(__props) {
        const inputFile = ref(null);
        const props = __props;
        const loading = ref(false);
        function upload() {
            const files = inputFile.value.files;
            if (files.length === 0) {
                return;
            }
            loading.value = true;
            uploadShopImportProfileFile(props.profile, files[0])
                .finally(() => {
                loading.value = false;
            });
        }
        function consumesMimeTypes() {
            return props.profile._meta.consumes
                .map((consumes) => consumes.mimeType)
                .reduce((t1, t2) => `${t1},${t2}`);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("form", {
                    enctype: "multipart/form-data",
                    method: "post",
                    class: "form form--simple",
                    onSubmit: _withModifiers(upload, ["prevent"])
                }, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('import_profile.transfer.file')), 1)
                        ]),
                        _cache[0] || (_cache[0] = _createTextVNode()),
                        _createElementVNode("input", {
                            type: "file",
                            accept: consumesMimeTypes(),
                            ref_key: "inputFile",
                            ref: inputFile,
                            id: "inputFile",
                            class: "form-control"
                        }, null, 8, _hoisted_5)
                    ]),
                    _cache[1] || (_cache[1] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("button", {
                            type: "submit",
                            class: "button",
                            disabled: loading.value
                        }, _toDisplayString(_ctx.$t('import_profile.transfer.do_upload')), 9, _hoisted_7)
                    ])
                ], 32)
            ]));
        };
    }
});
